import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { customerActions } from "stores/customer/customerActions";
import { thirdpartyActions } from "stores/thirdparty/thirdpartyActions";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";

const mapStateToProps = (state) => {
  const lockAmountInput = state.jarvisPrime.primeOnboarding.isPaymentCompleted
    ? true
    : false;
  return {
    customerProfile: state.customer.profile,
    currentStagePrime: state.jarvisPrime.primeOnboarding.currentStagePrime,
    loginProfile: state.customer.loginProfile,
    riskProfiles: state.common.riskProfiles,
    investmentStrategies: state.common.investmentStrategies,
    subscriptionPlans: state.thirdparty.subscriptionPlans,

    portfolioData: state.jarvisPrime.primeOnboarding.portfolioData,
    marketBreakupData: state.jarvisPrime.primeOnboarding.marketBreakupData,
    sectorBreakupData: state.jarvisPrime.primeOnboarding.sectorBreakupData,

    isRiskProfilesLoading: state.common.loading.riskProfiles,
    isportfolioDataLoading: state.jarvisPrime.primeOnboarding.portfolioData,
    isPaymentCompleted: state.jarvisPrime.primeOnboarding.isPaymentCompleted,
    isSubscriptionPlansLoading: state.thirdparty.loading.subscriptionPlans,
    isSubscriptionPlansCalled:
      state.thirdparty.isInitialCalled.subscriptionPlans,
    hasOnboardingInvestmentDetailsConfirmed:
      state.jarvisPrime.primeOnboarding.hasOnboardingInvestmentDetailsConfirmed,

    investmentInfo: {
      investmentAmount: state.jarvisPrime.primeOnboarding.investmentAmount,
      investmentTenure: state.jarvisPrime.primeOnboarding.investmentTenure,
      investmentStrategy: state.jarvisPrime.primeOnboarding.investmentStrategy,
      riskProfile: state.jarvisPrime.primeOnboarding.riskMasterId,
      planId: state.jarvisPrime.primeOnboarding.planId,
    },
    //
    lockAmountInput: false,
    investmentAmount: state.jarvisPrime.primeOnboarding.investmentAmount,
    investmentTenure: state.jarvisPrime.primeOnboarding.investmentTenure,
    investmentStrategy: state.jarvisPrime.primeOnboarding.investmentStrategy,

    minInvestmentAmount: state.jarvisPrime.primeOnboarding.minInvestmentAmount,
    // Tenure & strategy
    tenurePreferences: [
      { id: 2, label: "2 Yr", value: 2 },
      { id: 3, label: "3 Yr", value: 3 },
      { id: 5, label: "5 Yr", value: 5 },
      { id: 7, label: "7 Yr", value: 7 },
      { id: 11, label: "Other", value: "other" },
    ],
    tenurePreferencesList: [
      { year: 1, display: "1 Year" },
      { year: 4, display: "4 Year" },
      { year: 6, display: "6 Year" },
      { year: 8, display: "8 Year" },
      { year: 9, display: "9 Year" },
      { year: 10, display: "10 Year" },
    ],

    // Amont & plan
    investmentPlanList: [2500000, 5000000, 7500000, 10000000, "other"],
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRiskProfilesAction: commonActions.getRiskProfiles,
      getPortfolioData: jarvisPrimeOnboardingActions.getPortfolioData,
      updatePrimeOnboardingDataAction:
        jarvisPrimeOnboardingActions.updatePrimeOnboardingData,
      getOnboardingDataAction: jarvisPrimeOnboardingActions.getOnboardingData,
      setToastAction: commonActions.setToast,
      getSubscriptionPlansAction: thirdpartyActions.getSubscriptionPlans,
      getProfileDataAction: customerActions.getProfile,
      getPlanPrice: thirdpartyActions.getPlanPrice,
    },
    dispatch
  );

const PrimeCreationStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default PrimeCreationStore;
